import { useEffect, useRef, useState } from "react";

const stats = [
  { value: 500, suffix: "+", label: "Candidates Placed" },
  { value: 100, suffix: "+", label: "Happy Clients" },
  { value: 5, suffix: "+", label: "Years of Experience" },
  { value: 15, suffix: "+", label: "Industries Served" },
  { value: 50, suffix: "+", label: "Bulk Hiring Drives" },
  { value: 20, suffix: "+", label: "Cities Covered" },
];

function Counter({ target, suffix }) {
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !started.current) {
          started.current = true;
          const duration = 1500;
          const start = performance.now();
          const step = (now) => {
            const p = Math.min((now - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setVal(Math.round(target * eased));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.5 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <span ref={ref} className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-bee-honey">
      {val}
      {suffix}
    </span>
  );
}

export default function Stats() {
  return (
    <section
      id="impact"
      className="py-20 lg:py-24 bg-bee-teal text-white relative overflow-hidden"
      data-testid="stats-section"
    >
      <div className="absolute inset-0 honeycomb-divider opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs uppercase tracking-[0.2em] text-bee-honey font-semibold mb-3">Creating Impact</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Numbers that tell our story
          </h2>
        </div>
        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {stats.map((s, i) => (
            <div key={s.label} className="text-center" data-testid={`stat-card-${i}`}>
              <Counter target={s.value} suffix={s.suffix} />
              <div className="text-[11px] sm:text-xs uppercase tracking-wider text-white/75 mt-2">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
